import script from "./GastronomyHowToArriveSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./GastronomyHowToArriveSection.vue?vue&type=script&setup=true&lang=ts"

import "./GastronomyHowToArriveSection.vue?vue&type=style&index=0&id=e2f13c14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2f13c14"]])

export default __exports__